export interface Region {
  name: string
  logo: string
  plan: string
  apiBaseUrl: string
  envKey: string
  prod: boolean
}

export const regions: Region[] = [
  {
    name: '中国',
    logo: 'i-lucide-flag',
    plan: 'China',
    prod: true,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_CN || 'https://console.spatialwalk.top',
    envKey: 'cn',
  },
  {
    name: '美国',
    logo: 'i-lucide-globe',
    plan: 'USA',
    prod: true,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_US || 'https://console.spatialwalk.cloud',
    envKey: 'us',
  },
  {
    name: '测试',
    logo: 'i-lucide-bug',
    plan: 'Test',
    prod: false,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_TEST || 'https://console-test.spatialwalk.top',
    envKey: 'test',
  },
  {
    name: '开发',
    logo: 'i-lucide-code',
    plan: 'Dev',
    prod: false,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL_DEV || 'http://localhost:8083',
    envKey: 'dev',
  },
].filter(region => import.meta.env.VITE_ENV === 'prod' ? region.prod : !region.prod)
